var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInvitedCollaborator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 14,
  stroke: "var(--grey-darken-33)",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--grey-darken-33)",
  d: "M8.87 12.936 17 17.429l8.13-4.493a1.715 1.715 0 0 0-1.701-1.507H10.572c-.877 0-1.6.658-1.702 1.507"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--grey-darken-33)",
  d: "M25.143 15.072 17 19.572l-8.143-4.5v6.642c0 .947.768 1.715 1.715 1.715h12.857c.946 0 1.714-.768 1.714-1.715z"
})));
export default SvgInvitedCollaborator;